import type { FeedFilters } from '@/features/markets/components/Feed/api/fetchFeedData';

export const feedKeys = {
  all: ['feed'] as const,
  data: (metadata: FeedFilters) => [...feedKeys.all, metadata] as const,
  latestArticles: (params: { feedKeyCategories: string[] }) =>
    [...feedKeys.all, 'latestArticles', params] as const
};
